import React, { useState, useContext, useEffect } from 'react';
import { MyContext } from './MyContext';
import useDowntimeAnalytics from './useDowntimeAnalytics'
import {List, ListItem, ListItemText } from '@material-ui/core/';

const DowntimeTable = ({ selectedShifts, startDate, endDate, selectedReasonCodes }) => {


    const { downtimeReport, selectedMachines } = useContext(MyContext);
    const { topDowntimeMachine } = useDowntimeAnalytics({ selectedShifts, startDate, endDate, selectedReasonCodes });
    const [topMachines, setTopMachines] = useState([])

    useEffect(() => {
        if (topDowntimeMachine) {
            console.log("DowntimeTable topDowntimeMachine: " + topDowntimeMachine.size)
            //convert to array
            var topMachine = []
            Array.from(topDowntimeMachine.values()).forEach(element => {
                Array.from(element.entries()).forEach(machine => {
                    var machineName=machine[0]
                    var downtime=machine[1]
                    const foundMachine = topMachine.find(m=>m.machineName===machineName)
                    if (foundMachine) {
                        
                        foundMachine.downtime += downtime
                    }
                    else {
                        topMachine.push({machineName:machineName, downtime:downtime})
                    }
                })
            });
            //sort from largest to smallest downtime
            topMachine.sort((a, b) => (a.downtime > b.downtime) ? -1 : 1);
            setTopMachines(topMachine)

        }
    }, [topDowntimeMachine]);
    useEffect(() => {
        if (selectedReasonCodes) {
            console.log("DowntimeTable selectedReasonCodes: " + selectedReasonCodes.length)
        }
    }, [selectedReasonCodes]);


    return (
        <List>
             <span style={{marginLeft:20, fontSize:25}}><b>Down Time By Machine</b></span>
            <ol style={{height: '400px', overflow:'hidden', overflowY:'scroll'}}>
           
            {topMachines.map(machine=>{
           
            
                //console.log("machine name " + machine.machineName)
                return(
                    <li>
                <ListItem>
                    <ListItemText primaryTypographyProps={{ style: {color:'black', fontSize:20, fontWeight:25} }} primary={`${machine.machineName} -- ${Math.round(machine.downtime/60 * 10)/10}hrs` }/>
                    </ListItem>
                    </li>
                )
           
            
        })}
        
        </ol>
            </List>
    );


};
export default DowntimeTable;